<template>
  <div>
    <p class="title-page">Serviços</p>
    <TableServices />
  </div>
</template>

<script>
import TableServices from "../components/TableServices.vue";

export default {
  name: "ServicosPrestados",

  components: {
    TableServices
  }
};
</script>
